export function formatProjectName(name: string): string {
  const base = name.includes('/') ? name.split('/').pop()! : name
  return base
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim()
}
